<main class="custom-imports" [class.custom-imports--admin]="hasGlobalDataScope">
  <section class="custom-imports__container">
    <header class="custom-imports__header">
      <div>
        <h1>
          {{ 'customImports.title' | translate }}
        </h1>
        <p>{{ 'customImports.subtitle' | translate }}</p>
      </div>
      <button type="button"
              class="primary-btn"
              (click)="openCreatePanel()">
        {{ 'customImports.actions.new' | translate }}
      </button>
    </header>


    <div class="custom-imports__toolbar">
      <div class="toolbar-summary">
        <div class="status-pills">
          <button
            *ngFor="let status of availableStatuses"
            type="button"
            class="status-pill"
            [class.is-active]="statusFilters[status.id]"
            [style.--status-color]="statusColors[status.id]"
            [attr.aria-pressed]="statusFilters[status.id]"
            [attr.title]="status.labelKey | translate"
            (click)="toggleStatusFilter(status.id)">
            <span class="status-pill__count" aria-hidden="true">{{ statusCounts[status.id] || 0 }}</span>
            <span class="status-pill__label">{{ status.labelKey | translate }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="custom-imports__filters surface-card">
      <div class="custom-imports__filter-field">
        <label>{{ 'customImports.filters.search' | translate }}</label>
        <div class="custom-imports__filter-control">
          <input type="search"
                 [value]="searchTerm"
                 [placeholder]="'customImports.filters.searchPlaceholder' | translate"
                 (input)="onSearch($any($event.target).value)">
          <button type="button"
                  class="ghost-btn compact"
                  (click)="clearSearch()"
                  *ngIf="searchTerm">
            ×
          </button>
        </div>
      </div>
    </div>

    <section class="custom-imports__layout">
      <div class="custom-imports__card surface-card">
        <div class="custom-imports__table-header" *ngIf="!isLoading && !loadingError && filteredImports.length">
          <span>{{ 'customImports.table.name' | translate }}</span>
          <span>{{ 'customImports.table.owner' | translate }}</span>
          <span>{{ 'customImports.table.exportIds' | translate }}</span>
          <span>{{ 'customImports.table.tncids' | translate }}</span>
          <span>{{ 'customImports.table.status' | translate }}</span>
          <span class="custom-imports__header-spacer" aria-hidden="true"></span>
        </div>

        <div class="custom-imports__list">
          <p class="list-status" *ngIf="isLoading">{{ 'customImports.states.loading' | translate }}</p>
          <p class="list-status error" *ngIf="!isLoading && loadingError">{{ loadingError }}</p>

          <ng-container *ngIf="!isLoading && !loadingError && filteredImports.length; else customImportsState">
            <div class="custom-imports__row" *ngFor="let item of paginatedImports">
              <span class="custom-imports__name">
                <strong>{{ item.name }}</strong>
                <small>{{ item.exportIdTypeName }}</small>
                <small class="custom-imports__id" *ngIf="advanced">
                  <span class="custom-imports__id-value" [title]="item.id">{{ item.id | slice:0:8 }}…</span>
                  <button type="button"
                          class="custom-imports__id-copy"
                          [title]="'common.copy' | translate"
                          (click)="copyId(item.id, $event)">⧉</button>
                  <span class="custom-imports__id-copied" *ngIf="copiedImportId === item.id">{{ 'common.copied' | translate }}</span>
                </small>
              </span>
              <span class="custom-imports__meta">
                <div class="custom-imports__owner-primary">{{ item.owner }}</div>
              </span>
              <span class="custom-imports__count">
                <strong>{{ item.exportIdCount | number:'1.0-0':locale }}</strong>
              </span>
              <span class="custom-imports__count">
                <strong>{{ item.tncIdsCount | number:'1.0-0':locale }}</strong>
              </span>
              <span>
                <div class="custom-imports__active-cell">
                  <label class="custom-imports__toggle">
                    <input type="checkbox"
                           [checked]="item.status === 'active'"
                           (change)="toggleStatus(item)">
                    <span class="custom-imports__toggle-slider"></span>
                  </label>
                </div>
              </span>
            <div class="custom-imports__actions">
              <button type="button"
                      class="custom-imports__action-trigger"
                        aria-haspopup="menu"
                        [attr.aria-expanded]="activeActionMenuId === item.id"
                        (click)="toggleActionsMenu(item, $event)">
                  <svg viewBox="0 0 20 20" role="presentation" aria-hidden="true">
                    <circle cx="10" cy="4" r="1.5" />
                    <circle cx="10" cy="10" r="1.5" />
                    <circle cx="10" cy="16" r="1.5" />
                  </svg>
                </button>
              </div>
            </div>
          </ng-container>

          <ng-template #customImportsState>
            <p class="list-status" *ngIf="!isLoading && !loadingError && !filteredImports.length">
              {{ 'customImports.states.empty' | translate }}
            </p>
          </ng-template>
        </div>

        <div class="pagination-controls" *ngIf="!isLoading && filteredImports.length">
          <div class="page-size">
            <label>{{ 'customImports.pagination.rowsPerPage' | translate }}</label>
            <select [value]="pageSize" (change)="changePageSize($event)">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
          </div>
          <div class="page-navigation">
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 0">
              ‹
            </button>
            <span class="page-info">
              {{ 'customImports.pagination.page' | translate:{ current: ((currentPage + 1) | number:'1.0-0':locale), total: (totalPages | number:'1.0-0':locale) } }}
            </span>
            <button type="button"
                    class="ghost-btn"
                    (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage + 1 >= totalPages">
              ›
            </button>
          </div>
        </div>
        <ng-container *ngIf="activeActionItem as menuItem">
          <div class="custom-imports__action-menu"
               role="menu"
               [class.custom-imports__action-menu--above]="actionMenuOpenUpward"
               [style.top]="actionMenuPosition.top != null ? actionMenuPosition.top + 'px' : null"
               [style.bottom]="actionMenuPosition.bottom != null ? actionMenuPosition.bottom + 'px' : null"
               [style.left.px]="actionMenuPosition.left"
               [style.--custom-imports-action-arrow-left]="actionMenuArrowOffset + 'px'">
            <div class="custom-imports__action-menu-label">{{ 'customImports.actions.menuTitle' | translate }}</div>
            <button type="button"
                    class="custom-imports__action-item"
                    (click)="openEditPanel(menuItem)">
              <span class="action-icon action-icon--edit" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <path d="M3 14.5V17h2.5L15.4 7.1l-2.5-2.5L3 14.5z" />
                  <path d="M12.2 4.1l2.5 2.5 1.4-1.4c.4-.4.4-1 0-1.4L14 2.2c-.4-.4-1-.4-1.4 0l-1.4 1.9z" />
                </svg>
              </span>
              <span>{{ 'customImports.actions.edit' | translate }}</span>
            </button>
            <button type="button"
                    class="custom-imports__action-item"
                    (click)="toggleStatus(menuItem)">
              <span class="action-icon action-icon--pause" aria-hidden="true">
                <svg viewBox="0 0 20 20">
                  <rect x="6" y="4" width="2.5" height="12" rx="1" />
                  <rect x="11.5" y="4" width="2.5" height="12" rx="1" />
                </svg>
              </span>
              <span>
                {{ menuItem.status === 'active'
                    ? ('customImports.actions.deactivate' | translate)
                    : ('customImports.actions.activate' | translate) }}
              </span>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="custom-imports__form-wrapper" *ngIf="panelOpen">
        <app-custom-imports-form
          [mode]="formMode"
          [exportIdTypes]="exportIdTypes"
          [currentUser]="currentUser"
          [initialValue]="editingImport"
          [hasGlobalDataScope]="hasGlobalDataScope"
          [ownerEntityOptions]="ownerEntityOptions"
          [advanced]="advanced"
          (saved)="handleFormSaved()"
          (cancelled)="closePanel()"
        ></app-custom-imports-form>
      </div>
    </section>
  </section>
</main>
